import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection13Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/mbxhjmkq9v`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection13Video;
